import { render, staticRenderFns } from "./UploadSupplierDocument.vue?vue&type=template&id=00b90998&"
import script from "./UploadSupplierDocument.vue?vue&type=script&lang=js&"
export * from "./UploadSupplierDocument.vue?vue&type=script&lang=js&"
import style0 from "./UploadSupplierDocument.vue?vue&type=style&index=0&id=00b90998&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports